export default __webpack_public_path__ + "static/media/sort-2.cd28a816.svg";